import React, { FC } from 'react'
import { useStaticQuery } from "gatsby"
import { graphql } from "gatsby"
import { OtherArticles } from '../OtherArticles/OtherArticles';
import ClientSearch from './ArticleSearch'
import {  ArticleNode, ArticleSideBarProps, GetNonBlogCategories, IndexQueryData } from '../../utils/core';

// Load NON_BLOG_CATEGORIES from the environment variable
const NON_BLOG_CATEGORIES = GetNonBlogCategories();; // Remove empty strings

const ArticleSideBar: FC<ArticleSideBarProps> = ({ currentSlug }) => {
  const data: IndexQueryData = useStaticQuery(IndexQuery);

  const options = {
    indexStrategy: `All`,
    searchSanitizer: `Lower Case`,
    TitleIndex: true,
    AuthorIndex: true,
    ContentIndex: true,
    SearchByTerm: true,
  };

  const edges = data?.allMarkdownRemark?.edges;

  const articles: ArticleNode[] = edges
  .filter((post) => {
    const category = post.node.frontmatter.category?.toLowerCase();
    return !NON_BLOG_CATEGORIES.includes(category); // Exclude 'successstory' and 'legal'
  })
  .map((post): ArticleNode => {
    const { id, html, frontmatter, fields } = post.node;
    return {
      id,
      html,
      frontmatter,
      fields,
    };
  });

  return (
    <div className="widget-area">
      <ClientSearch articles={articles} engine={options} />
      <OtherArticles articles={articles} currentSlug={currentSlug} />
    </div>
  );
};

export const IndexQuery = graphql`
query {
  allMarkdownRemark(
    sort: { frontmatter: { date: DESC } }
    ) {
    edges {
      node {
        id
        html
        frontmatter {
          title
          slug
          date
          category
          blogimage {
              childImageSharp {
                gatsbyImageData
              }
            }
            serieslabel
        }
        fields{
          language
        }
      }
    }
  }
}
`;


export default ArticleSideBar